import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import OriginCards from './components/OriginCards';
import BrewGuide from './components/BrewGuide';
import ReviewsAndFAQ from './components/ReviewsAndFAQ';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import { teas, teaware } from './data/storeData';

function App() {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Prevent background scrolling when cart is open
  useEffect(() => {
    if (isCartOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isCartOpen]);

  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find(item => item.id === product.id);
      if (existingItem) {
        return prevCart.map(item => 
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      }
      return [...prevCart, { ...product, quantity: 1 }];
    });
  };

  const updateQuantity = (id, newQuantity) => {
    if (newQuantity < 1) return;
    setCart((prevCart) => 
      prevCart.map(item => item.id === id ? { ...item, quantity: newQuantity } : item)
    );
  };

  const removeItem = (id) => {
    setCart((prevCart) => prevCart.filter(item => item.id !== id));
  };

  const cartItemCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <div className="bg-moon-white min-h-screen text-gray-800 font-sans selection:bg-jade/20 selection:text-plum-dark overflow-x-hidden">
      <Navbar 
        cartItemCount={cartItemCount} 
        onOpenCart={() => setIsCartOpen(true)} 
      />
      
      <CartDrawer 
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cart={cart}
        updateQuantity={updateQuantity}
        removeItem={removeItem}
      />
      
      <Hero />
      
      <main>
        <ProductSection 
          id="shop" 
          title="The Autumn Harvest Collection" 
          products={teas} 
          onAddToCart={addToCart}
        />
        
        <OriginCards />
        
        <ProductSection 
          id="teaware" 
          title="Artisanal Teaware Bundles" 
          products={teaware} 
          onAddToCart={addToCart}
        />
        
        <BrewGuide />
        <ReviewsAndFAQ />
      </main>

      <Footer />
    </div>
  );
}

export default App;